var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTopCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.629 24 24 18.629 24 12C24 5.37094 18.629 -3.05176e-05 12 -3.05176e-05C5.37097 -3.05176e-05 0 5.37094 0 12C0 18.629 5.37097 24 12 24ZM12 2.32255C17.3468 2.32255 21.6774 6.6532 21.6774 12C21.6774 17.3467 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3467 2.32258 12C2.32258 6.6532 6.65323 2.32255 12 2.32255ZM12.9677 18.1935H11.0323C10.7129 18.1935 10.4516 17.9322 10.4516 17.6129L10.4516 12H7.20968C6.69193 12 6.43548 11.3758 6.79839 11.008L11.5887 6.21771C11.8161 5.99029 12.1839 5.99029 12.4113 6.21771L17.2016 11.008C17.5694 11.3758 17.3081 12 16.7903 12H13.5484L13.5484 17.6129C13.5484 17.9322 13.2871 18.1935 12.9677 18.1935Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopCircle);
export default __webpack_public_path__ + "static/media/icon-top-circle.3200bca21e92eaa7a08e1d8f1cbccdb7.svg";
export { ForwardRef as ReactComponent };